import { Injectable } from '@angular/core';
import { ComponentBase } from '../../../component-base';
import { MatDialog } from '@angular/material';
import {
  IDialogResult,
  TextEditorComponent
} from '../ng-components/text-editor/text-editor.component';
import { DrawingsHolderService } from '../drawings-holder.service';
import { Text } from '../object3D';
import { IDoubleClick } from '../Interfaces';
import { DeleteObjectComponent } from './DeleteObjectComponent';

@Injectable()
export class EditTextComponent extends ComponentBase implements IDoubleClick {
  selectedObject: Text | null = null;

  constructor(
    private dialog: MatDialog,
    private drawings: DrawingsHolderService,
    private deleteComponent: DeleteObjectComponent
  ) {
    super();
    this.disable();
    this.drawings.onSelect.subscribe(obj => {
      if (obj) {
        this.selectedObject = obj[0] instanceof Text ? obj[0] : null;
      } else {
        this.selectedObject = null;
      }
    });
  }

  dblclick() {
    if (this.selectedObject) {
      this.deleteComponent.disable();
      const dialogRef = this.dialog.open(TextEditorComponent, {
        data: this.selectedObject.config,
        width: '450px'
      });
      dialogRef.afterClosed().subscribe((result: IDialogResult | undefined) => {
        if (result) {
          const object = this.selectedObject;
          object.config = result.config;
          object.update(result.image);
        }
        this.deleteComponent.enable();
      });
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/EditTextComponent.ts